
export class CustomAttributeViewModel {
  definitionId: string | undefined;
  type: string | undefined;
  index: number | undefined;
  label: string | undefined;
  value: string | undefined;
  convertedValue: string | undefined;


  constructor(payload?: any) {
    if (payload) {
      this.definitionId = payload.definitionId;
      this.type = payload.type;
      this.index = payload.index;
      this.label = payload.label;
      this.value = payload.value;
      this.convertedValue = payload.convertedValue;
    }
  }

  /**
   * creates models from a result
   * @param result Array of any
   * @returns Bookigs
   */
  static createCustomAttributeViewModels(result: Array<any>): CustomAttributeViewModel[] {
    const customAttributeViewModels = new Array<CustomAttributeViewModel>();
    if (result) {
      result?.map((customAttributeViewModel) => {
        customAttributeViewModels.push(new CustomAttributeViewModel(customAttributeViewModel));
      });
    }
    return customAttributeViewModels;
  }

}
